import React from 'react';
import { Helmet } from 'react-helmet';
import { Link, Navigate, useParams } from 'react-router-dom';
import { seoArticlesWithContent } from '../data/seoArticles';

function SeoArticlePage() {
  const { slug } = useParams();
  const article = seoArticlesWithContent.find((item) => item.slug === slug);

  if (!article) {
    return <Navigate to="/guias" replace />;
  }

  return (
    <>
      <Helmet>
        <title>{article.title}</title>
        <meta
          name="description"
          content={`${article.title}. Guía práctica para empresas que buscan resolver ${article.keyword} con más control, menos errores y una operativa más rentable.`}
        />
      </Helmet>

      <article className="light-page seo-article">
        <section className="light-page__hero" data-aos="fade-up">
          <div className="site-container">
            <p className="light-page__eyebrow">{article.groupLabel}</p>
            <h1>{article.title}</h1>
            <p>
              Esta guía responde a la búsqueda <strong>{article.keyword}</strong> con un enfoque práctico para dirección,
              administración y equipos operativos que necesitan más control y menos fricción.
            </p>
          </div>
        </section>

        <section className="light-page__section">
          <div className="site-container">
            <div className="light-page__reading-layout seo-article__layout">
              <div className="light-page__reading-body seo-article__body">
                {article.paragraphs.map((paragraph, index) => (
                  <p key={paragraph} data-aos="fade-up" data-aos-delay={(index % 3) * 60}>
                    {paragraph}
                  </p>
                ))}

                <section className="light-page__article-block seo-article__block" data-aos="fade-up">
                  <h2>Qué conviene revisar primero</h2>
                  <ul>
                    {article.checklist.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </section>

                <section className="light-page__article-block seo-article__block" data-aos="fade-up">
                  <h2>Preguntas frecuentes</h2>
                  <div className="seo-article__faq-list">
                    {article.faqs.map((faq, index) => (
                      <div
                        key={faq.question}
                        className="light-page__faq-item seo-article__faq-item"
                        data-aos="fade-up"
                        data-aos-delay={index * 70}
                      >
                        <h3>{faq.question}</h3>
                        <p>{faq.answer}</p>
                      </div>
                    ))}
                  </div>
                </section>

                <section className="light-page__cta light-page__cta--inline seo-article__cta" data-aos="fade-up">
                  <h2>¿Quieres aterrizar esta mejora en tu empresa?</h2>
                  <p>
                    Si tu caso encaja con <strong>{article.keyword}</strong>, podemos revisar el proceso actual, detectar
                    puntos de pérdida y plantear un plan de implantación realista.
                  </p>
                  <div className="seo-article__cta-actions">
                    <a href="/contacto#reserva" className="home-premium__cta">
                      Solicitar diagnóstico
                    </a>
                    <Link to="/guias" className="seo-hub__link">
                      Ver más guías
                    </Link>
                  </div>
                </section>
              </div>

              <aside className="light-page__reading-sidebar seo-article__sidebar" data-aos="fade-left" data-aos-delay="120">
                <div className="light-page__sticky-cta">
                  <p className="light-page__eyebrow">Diagnóstico</p>
                  <h2>¿Encaja con tu empresa?</h2>
                  <p>Revisamos el proceso actual y te digo qué conviene corregir antes de implantar más herramientas.</p>
                  <a href="/contacto#reserva" className="home-premium__cta home-premium__cta--small">
                    Solicitar diagnóstico
                  </a>
                </div>
                <div className="light-page__card seo-article__sidebar-card">
                  <h2>Keyword</h2>
                  <p>{article.keyword}</p>
                </div>
                <div className="light-page__card seo-article__sidebar-card">
                  <h2>Enfoque</h2>
                  <p>{article.groupLabel}</p>
                </div>
                <div className="light-page__card seo-article__sidebar-card">
                  <h2>Siguiente paso</h2>
                  <p>Ordenar datos, proceso y responsables antes de implantar más herramientas.</p>
                </div>
              </aside>
            </div>
          </div>
        </section>
      </article>
    </>
  );
}

export default SeoArticlePage;
